module.exports = __webpack_public_path__ + "static/media/opacity-pane.a0518f6d.png";